import { COLORS } from "../../constants";
import { globalVars } from "../../globalVariables";
import { settings } from "../../settings/settings";
import { BuffUtils } from "../../utils/buff";
import { getQT } from "../../utils/dom";
import { formatBuffTimer } from "../../utils/formatBuffTimer";
import { createTimer } from "../timers/createTimer";
export const updateBuffsTimer = () => {
    if (!settings.showBuffTimers)
        return;
    Object.keys(Game.buffs).forEach((key) => {
        const buff = Game.buffs[key];
        if (!buff)
            return;
        const { time } = buff;
        const buffId = BuffUtils.getId(buff);
        const buffTime = Math.ceil(time / Game.fps);
        const buffName = BuffUtils.getName(buff);
        const buffIcon = BuffUtils.getIcon(buff);
        const buffMult = BuffUtils.getMultiplier(buff);
        const buffMultColor = buffMult > 1 ? COLORS.green : COLORS.red;
        if (!globalVars.buffTimers.find((b) => b.id === buffId)) {
            createTimer(buffId);
            globalVars.buffTimers.push({ id: buffId, key });
        }
        const buffEl = getQT(buffId);
        if (!buffEl)
            return;
        buffEl.classList.toggle("qt_warning", buffTime <= 10);
        const showMult = buffMult !== 0 && settings.showMultipliers;
        buffEl.innerHTML = `
      ${buffIcon}<span>${buffName}: ${formatBuffTimer(buffTime)}</span> <span style="color: ${buffMultColor}; display: ${showMult ? "inline" : "none"};">x${parseFloat(buffMult.toFixed(1))}</span>
    `;
    });
    if (globalVars.buffTimers.length === Object.keys(Game.buffs).length)
        return;
    const activeKeys = new Set(Object.keys(Game.buffs));
    const deletedIds = [];
    globalVars.buffTimers.forEach((buff) => {
        if (activeKeys.has(buff.key))
            return;
        getQT(buff.id)?.remove();
        deletedIds.push(buff.id);
    });
    if (deletedIds.length) {
        globalVars.buffTimers = globalVars.buffTimers.filter((buff) => !deletedIds.includes(buff.id));
    }
};
